<div class="modal-header">
    <div class="lz-modal-close modal-close-btn" (click)="activeModal.dismiss('Cross click')" aria-label="Close"></div>
</div>
<div class="modal-body compliance" (keyup.enter)="signIn()" *ngIf="currentFormType == formTypeEnum.SignInExistingUser">
    <div *ngIf="currentFormType == formTypeEnum.SignInExistingUser" class="modal-mobile">
        <h2 class="modal-title modal-title-mb existinguser-modal-heading">We found your</h2>
        <h2 class="modal-title mb-3 existinguser-modal-heading account-desktop">account.</h2>
        <p class="mb-4 fs-16">Please sign in to complete your order:</p>
        <b class="modal-email">{{existingEmail}}</b>
        <div class="ng-error-msg" [style.display]="this.accountProcessingError === '' ? 'none' : 'block'">{{ accountProcessingError }}
        </div>
        <form [formGroup]="form" *ngIf="currentFormType == formTypeEnum.SignInExistingUser" novalidate>
            <div class="form-group mb-4 mt-4">
                <div class="input-group">
                    <input #password id="password" placeholder="Password" class="form-control" formControlName="password" type="password" />
                    <div class="input-group-btn">
                        <a class="btn btn-primary" (click)="togglePasswordVisibility()">
                            <i class="fa fa-eye" *ngIf="isPasswordVisible"></i>
                            <i class="fa fa-eye-slash" *ngIf="! isPasswordVisible"></i>
                        </a>
                    </div>
                </div>
            </div>
            <p class="text-danger" *ngIf="accountProcessingError">{{ accountProcessingError }}</p>
        </form>
        <button type="button" id="btnSignIn" class="btn btn-primary btn-sm mb-4 btn-upgrade" (click)="signIn()">
            <span *ngIf="isLoading">
                <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </span>
            <span *ngIf="!isLoading">
                Sign in
            </span>
        </button>
        <div>
            <a class="modal-forgot" href="javascript:" (click)="changeFormType(formTypeEnum.ForgotPassword)">
                <b>Forgot password?</b>
            </a>
        </div>
        <div class="mt-4 modal-anotherAccount display-prop">
            Want to use another account?
        </div>
        <div class="display-prop">
            <a class="modal-anchor-text" href="javascript:" (click)="changeFormType(formTypeEnum.Login)">
                <b>Sign in</b>
            </a>
            <span class="modal-dash-style separator-mobile mr-2 ml-2">|</span>
            <span class="modal-dash-style separator-desktop ml-2 mr-2">or</span>
            <a class="modal-anchor-text" href="javascript:" (click)="changeFormType(formTypeEnum.SaveYourWork)">
                <b>Create account</b>
            </a>
        </div>
    </div>
</div>
<div class="save-progress modal-body" (keyup.enter)="signIn()" [ngSwitch]="currentFormType" *ngIf="currentFormType !== formTypeEnum.SignInExistingUser">
    <div class="text-center">
        <div *ngSwitchCase="formTypeEnum.Login">
            <h2 class="modal-title mb-3">Sign In</h2>
            <p class="mb-4 fs-16">Enter your email and password below.</p>
        </div>
        <div *ngSwitchCase="formTypeEnum.SaveYourWork">
            <h2 class="modal-title mb-3">Create Account</h2>
            <p class="mb-4 fs-16">Please enter your email and choose a password:</p>

        </div>
        <div *ngSwitchCase="formTypeEnum.ForgotPassword">
            <h2 class="modal-title mb-3">Forgot password</h2>
            <p class="mb-4 fs-16">Enter your email address to recover your password.</p>
        </div>
        <div *ngSwitchCase="formTypeEnum.LZLogoSaveYourProgress">
            <h2 class="modal-title mb-4">Save your progress before you go</h2>
            <p class="px-2">Not ready to finish your order? Create an account and we’ll save your progress so you can resume anytime.</p>
        </div>
    </div>

    <form [formGroup]="form" *ngIf="currentFormType !== formTypeEnum.LZLogoSaveYourProgress" novalidate>
        <div class="form-group">
            <input id="guestExistingUserEmail" placeholder="Email address" class="form-control" formControlName="email" type="text" />
        </div>
        <div class="form-group" *ngIf="currentFormType !== formTypeEnum.ForgotPassword">
            <div class="input-group">
                <input #password id="password" class="form-control" placeholder="Password" formControlName="password" type="password" />
                <div class="input-group-btn">
                    <a class="btn btn-primary" (click)="togglePasswordVisibility()">
                        <i class="fa fa-eye" *ngIf="isPasswordVisible"></i>
                        <i class="fa fa-eye-slash" *ngIf="! isPasswordVisible"></i>
                    </a>
                </div>
            </div>
        </div>



        <p class="text-danger" *ngIf="accountProcessingError">{{ accountProcessingError }}</p>
    </form>
</div>
<ng-container *ngIf="currentFormType !== formTypeEnum.LZLogoSaveYourProgress; else LZLogoSaveYourProgressForm">
    <div class="modal-footer d-block text-center">
        <p *ngIf="currentFormType === formTypeEnum.SaveYourWork" class="fs-12 mb-4">By clicking the button, I agree to the
            <a href="https://www.legalzoom.com/legal/general-terms/privacy-policy" target="_blank">Privacy Policy</a> and
            <a href="https://www.legalzoom.com/legal/general-terms/terms-of-use" target="_blank">Terms of Use</a>.
        </p>

        <div [ngSwitch]="currentFormType">
            <button *ngSwitchCase="formTypeEnum.Login" type="button" id="btnSignIn" class="btn btn-primary btn-sm btn-upgrade mb-4" (click)="signIn()">
                <span *ngIf="isLoading">
                    <i class="fa fa-spinner fa-pulse fa-fw"></i>
                </span>
                <span *ngIf="!isLoading">
                    Sign in
                </span>
            </button>
            <button *ngSwitchCase="formTypeEnum.SaveYourWork" id="btnCreateAccount" type="button" class="btn btn-primary btn-sm btn-upgrade mb-4"
                (click)="createMyAccount()">
                <span *ngIf="isLoading">
                    <i class="fa fa-spinner fa-pulse fa-fw"></i>
                </span>
                <span *ngIf="!isLoading">
                    Create account
                </span>
            </button>
            <button *ngSwitchCase="formTypeEnum.ForgotPassword" id="btnSendPassword" type="button" class="btn btn-primary btn-sm btn-upgrade mb-4"
                (click)="forgotPassword()">
                <span *ngIf="isLoading">
                    <i class="fa fa-spinner fa-pulse fa-fw"></i>
                </span>
                <span *ngIf="!isLoading">
                    Send password reset
                </span>
            </button>
        </div>

        <div class="display-prop mb-4" *ngIf="currentFormType == formTypeEnum.Login">

            <a class="modal-anchor-text" href="javascript:" (click)="changeFormType(formTypeEnum.SaveYourWork)">
                <b>Create account</b>
            </a>
            <span class="modal-dash-style separator-mobile mr-2 ml-2">|</span>
            <span class="modal-dash-style separator-desktop ml-2 mr-2">or</span>
            <a class="modal-anchor-text" href="javascript:" (click)="changeFormType(formTypeEnum.ForgotPassword)">
                <b>Forgot Password?</b>
            </a>
        </div>
        <div class="mb-4" *ngIf="currentFormType == formTypeEnum.SaveYourWork">
            <p class="fs-16">Already have an account?
                <a class="modal-anchor-text" href="javascript:" (click)="changeFormType(formTypeEnum.Login)">Sign in</a>.
            </p>
        </div>
    </div>
</ng-container>
<ng-template #LZLogoSaveYourProgressForm>
    <div class="save-progress modal-footer d-block text-center" *ngIf="currentFormType === formTypeEnum.LZLogoSaveYourProgress">
        <div class="mb-3">
            <button type="button" class="btn btn-primary btn-sm" (click)="openForm(formTypeEnum.SaveYourWork)">
                <span>
                    Create account
                </span>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="openForm(formTypeEnum.Login)">
                <span>
                    Sign in
                </span>
            </button>
        </div>
        <div class="mb-lg-3">
            <button type="button" class="btn btn-link btn-sm btn-block" (click)="gotoHomePage()">
                <span>
                    Leave without saving
                </span>
            </button>
        </div>
    </div>
</ng-template>
